<template>
  <div
    dir="rtl"
    class="salary-page"
  >

    <div class="page-header">
      <h1>رواتب موظفي {{ $brand.nameArFull }}</h1>
      <p>كشف رواتب شهر {{ getArabicMonthName() }} — سنة {{ currentYear }}</p>
    </div>

    <table class="salary-table">
      <thead>
        <tr>
          <th>ت</th>
          <th>الاسم الثلاثي</th>
          <th>العنوان الوظيفي</th>
          <th>الاسمي</th>
          <th>الإضافي</th>
          <th>الاستقطاع</th>
          <th>الصافي</th>
          <th>تاريخ الدفع</th>
          <th>الملاحظات</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(emp, index) in data"
          :key="index"
        >
          <td>{{ index + 1 }}</td>
          <td>{{ emp.full_name }}</td>
          <td>
            {{ emp.job ? emp.job.title : '—' }}
          </td>
          <td>{{ formatNum(emp.base_salary) }}</td>
          <td>{{ formatNum(getSalaryField(emp, 'additional_salary')) }}</td>
          <td class="deduction">
            {{ formatNum(getSalaryField(emp, 'deduction_salary')) }}
          </td>
          <td class="net">
            {{ formatNum(getSalaryField(emp, 'total_salary')) }}
          </td>
          <td>{{ getSalaryField(emp, 'paid_date') }}</td>
          <td />
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="3">
            المجموع الكلي
          </td>
          <td>{{ formatNum(total.base) }}  </td>
          <td>{{ formatNum(total.additional) }}</td>
          <td class="deduction">
            {{ formatNum(total.deduction) }}
          </td>
          <td class="net">
            {{ formatNum(total.net) }}
          </td>
          <td />
          <td />
        </tr>
      </tfoot>
    </table>

    <div class="sig-section">
      <div class="sig-box">
        <p class="sig-title">
          توقيع المحاسب
        </p>
        <div class="sig-line" />
        <p class="sig-label">
          الاسم: ________________________
        </p>
      </div>
      <div class="sig-box">
        <p class="sig-title">
          توقيع المدير
        </p>
        <div class="sig-line" />
        <p class="sig-label">
          الاسم: ________________________
        </p>
      </div>
      <!-- <div class="sig-box">
        <p class="sig-title">
          اعتماد المدير العام
        </p>
        <div class="sig-line" />
        <p class="sig-label">
          الاسم: ________________________
        </p>
      </div> -->
    </div>

  </div>
</template>

<script>
export default {
  props: {
    data: { type: Array, required: true },
  },
  computed: {
    total() {
      return this.data.reduce((acc, emp) => {
        const s = emp.salary || {}
        return {
          base: acc.base + (emp.base_salary || 0),
          additional: acc.additional + (s.additional_salary || 0),
          deduction: acc.deduction + (s.deduction_salary || 0),
          net: acc.net + (s.total_salary || 0),
        }
      }, {
        base: 0, additional: 0, deduction: 0, net: 0,
      })
    },
    currentYear() {
      return new Date().getFullYear()
    },
  },
  methods: {
    getSalaryField(emp, field) {
      return emp.salary ? emp.salary[field] : null
    },
    getArabicMonthName() {
      const months = [
        'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
        'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر',
      ]
      return months[new Date().getMonth()]
    },
    formatNum(n) {
      return n != null ? Number(n).toLocaleString('en-US') : '—'
    },
  },
}
</script>

<style scoped>
.salary-page { font-family: sans-serif; padding: 24px; direction: rtl; }

.page-header { text-align: center; margin-bottom: 20px; }
.page-header h1 { font-size: 18px; font-weight: 500; }
.page-header p  { font-size: 13px; color: #666; margin-top: 4px; }

.salary-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.salary-table th,
.salary-table td { border: 1px solid #ddd; padding: 10px 8px; text-align: center; }
.salary-table thead { background: #f5f5f5; font-weight: 500; }
.salary-table tfoot { background: #fafafa; font-weight: 500; }
.salary-table td:nth-child(2) { text-align: right; }
.net       { color: #2a7a2a; font-weight: 500; }
.deduction { color: #c0392b; }

.sig-section { display: flex; gap: 24px; margin-top: 48px; }
.sig-box { flex: 1; border: 1px solid #ddd; border-radius: 8px; padding: 16px; text-align: center; }
.sig-title { font-size: 13px; font-weight: 500; margin-bottom: 8px; }
.sig-line  { height: 36px; border-bottom: 1px solid #333; margin-bottom: 10px; }
.sig-label { font-size: 12px; color: #777; }

@media print {
  .salary-page { padding: 0; }
  .sig-section { margin-top: 64px; }
}
</style>
